import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "flex items-center w-full h-6" };
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useRetroStore } from '@/pinia_stores/retro';
import ReactionPill from '@/components/topics/ReactionPill.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Reactions',
    props: {
        topic: null
    },
    setup(__props) {
        const props = __props;
        const retroStore = useRetroStore();
        const { currentPoster, isParticipant, isCurrentUserPosting, users } = storeToRefs(retroStore);
        const { createTopicReaction, deleteTopicReaction } = retroStore;
        const topicIsFromCurrentPoster = computed(() => props.topic.userId === currentPoster.value?.id);
        const handleReact = ({ type, target }) => {
            if (target) {
                createTopicReaction(props.topic.id, type);
            }
            else {
                deleteTopicReaction(props.topic.id, type);
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['clap', 'confetti', 'rocket', 'sad'], (reactionType) => {
                    return _createVNode(ReactionPill, {
                        key: reactionType,
                        type: reactionType,
                        reactable: _unref(isParticipant) && !_unref(isCurrentUserPosting) && _unref(topicIsFromCurrentPoster),
                        reactions: __props.topic.reactions.filter((r) => r.type === reactionType),
                        users: _unref(users),
                        onClick: handleReact
                    }, null, 8, ["type", "reactable", "reactions", "users"]);
                }), 64))
            ]));
        };
    }
});
